import { createSlice } from '@reduxjs/toolkit'

import { fetchPrices_aggregated } from '../requests/thunks'
import type {
  DsaPricehelperArticle,
  DsaPricehelperError,
  DsaPricehelperResponse,
  DsaPricehelperSummary,
} from '../requests/apiRequests/postDsaPricehelper'

interface BundleState {
  errors: DsaPricehelperError[] | null
  articles: DsaPricehelperArticle[] | null
  summary: DsaPricehelperSummary | null
  articlesTotal: number | null
  _latestPendingRequestId: string
}

const initialState: BundleState = {
  errors: null, // []
  articles: null, // []
  summary: null, // {}
  articlesTotal: null, // int
  _latestPendingRequestId: '',
}

const bundleSlice = createSlice({
  name: 'bundle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrices_aggregated.pending, (state, action) => {
        state._latestPendingRequestId = action.meta.requestId
      })
      .addCase(fetchPrices_aggregated.fulfilled, (state, action) => {
        if (state._latestPendingRequestId === action.meta.requestId) {
          // fetchPrices_aggregated declares its payload as any, so the shape is pinned down here
          const {
            bundle: { errors, articles, summary },
          }: { bundle: DsaPricehelperResponse } = action.payload

          if (errors) {
            console.error('Received errors from pricehelper API: ', JSON.stringify(errors, null, 2))
            state.errors = errors
          } else {
            state.errors = null
          }

          // TODO: articles Scensum can't sell are silently left out of the response, so the summary can show too low a price
          state.articles = articles
          state.summary = summary
          state.articlesTotal = articles
            .map(({ Quantity }) => Quantity)
            .reduce((total: number, Quantity: number) => total + Quantity, 0)
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was fulfilled for deprecated DM 'configuration-update' event -- payload is ignored."
          )
        }
      })
      .addCase(fetchPrices_aggregated.rejected, (state, action) => {
        if (state._latestPendingRequestId === action.meta.requestId) {
          state.errors = null
          state.articles = null
          state.summary = null
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was rejected for deprecated DM 'configuration-update' event."
          )
        }
      })
  },
})

export default bundleSlice.reducer
